export function getClipboardFiles(
  clipboardData: DataTransfer | null | undefined
): File[] {
  if (!clipboardData) return [];

  const files = Array.from(clipboardData.files || []);
  if (files.length > 0) return files;

  return Array.from(clipboardData.items || [])
    .filter(item => item.kind === 'file')
    .map(item => item.getAsFile())
    .filter((file): file is File => file != null);
}

type PasteFilesListener = (files: File[]) => void;

const pasteFilesListeners = new Set<PasteFilesListener>();

export function subscribeAttachmentPasteFiles(
  listener: PasteFilesListener
): () => void {
  pasteFilesListeners.add(listener);
  return () => {
    pasteFilesListeners.delete(listener);
  };
}

export function emitAttachmentPasteFiles(files: File[]): boolean {
  if (!files.length || pasteFilesListeners.size === 0) return false;
  pasteFilesListeners.forEach(listener => listener(files));
  return true;
}
